/**
 *  Copyright 2023 OwlMeans
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

import { Wallet } from "../wallet/types"


export type BasicStore = {
  alias: string
  name: string
  comment?: string
}

export type EncryptedStore = BasicStore & {
  dataChunks?: string[]
  toRemove?: boolean
}

export type SecureStore = BasicStore & {
  data?: Wallet
}

export const ERROR_STORE_CANT_DECRYPT = 'ERROR_STORE_CANT_DECRYPT'